import CustomFormInput from "@components/CustomFormInput/CustomFormInput";
import { Button } from "@components/ui/button";
import { CreateProfileContext } from "@pages/CreateProfile/CreateProfileLayout";
import { RootState } from "@store/reducers";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
// @ts-ignore
import { updateCandidate } from "../../../../endpoints/candidate.service";
// @ts-ignore
import { setUserData } from "../../../../store/actions/auth.action";
// @ts-ignore
import LoadingAnimation from "../../../../assets/svg/LoadingAnimation";
import { colors } from "../../../../utils/theme";
import { updateUserProfile } from "@endpoints/auth.service";

const Step1 = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useSelector((state: RootState) => state.auth);
  const { setActiveStep, setSteps, setPreviewData } =
    useContext(CreateProfileContext)!;
  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      firstName: user?.firstName,
      lastName: user?.lastName,
      phoneNumber: "",
    },
  });

  const phone = watch("phoneNumber");

  useEffect(() => {
    const sub = watch((values) => {
      setPreviewData((prev) => ({
        ...prev,
        firstName: values.firstName,
        lastName: values.lastName,
      }));
    });
    return () => sub.unsubscribe();
  }, [watch, setPreviewData]);

  const onSubmit = handleSubmit(async (formData) => {
    try {
      setIsLoading(true);
      const { success, data } = await updateUserProfile(formData);
      if (success) {
        dispatch(setUserData(data));
        setSteps((prev) =>
          prev.map((step, i) =>
            i === 0 ? { ...step, isCompleted: true } : step,
          ),
        );
        setActiveStep((prev) => prev + 1);
      }
    } catch (error: any) {
      enqueueSnackbar(error?.message || "Unable to save details.", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  });

  return (
    <div className="flex flex-col w-[40%] bg-white rounded-2xl p-5 min-h-96 h-max">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-1">
          <span className="font-bold text-primary">Personal details</span>
          <span className="text-sm text-light-black">
            Enter your basic contact details.
          </span>
        </div>
        <span className="rounded-full font-semibold text-xss text-blue-600 bg-blue-50 px-2 py-0.5">
          Step 1
        </span>
      </div>
      {/* Form container */}
      <div className="flex flex-col w-full my-6 gap-3">
        <div className="flex items-center gap-5">
          <CustomFormInput
            name="firstName"
            register={register("firstName")}
            label="First name"
            placeholder="Enter your first name"
          />
          <CustomFormInput
            name="lastName"
            label="Last name"
            register={register("lastName")}
            placeholder="Enter your last name"
          />
        </div>
        <CustomFormInput
          type="phone"
          name="phoneNumber"
          value={phone}
          defaultCountry="gb"
          onChange={(val) => setValue("phoneNumber", val)}
          label="Mobile number"
          placeholder="Enter your mobile number"
        />
      </div>
      <Button
        variant="secondary"
        className="text-sm flex items-center justify-center gap-2"
        disabled={isLoading}
        onClick={onSubmit}
      >
        {isLoading && <LoadingAnimation color={colors.White} />}
        Next - add a profile picture
      </Button>
    </div>
  );
};

export default Step1;
